import { Routes } from '@angular/router';
import { CharityComponent } from './charity.component';
import { CharityDetailsComponent } from './charity-details/charity-details.component';

export const CharityRoute: Routes = [
  {
    path: '',
    component: CharityComponent
  },
  {
    path: ':slug',
    component: CharityDetailsComponent
  }
];